import { Component, OnInit } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
// import { EditorDialogComponent } from '../../dialogs/editor-dialog/editor-dialog.component';

@Component({
  selector: 'kve-seo-input',
  templateUrl: './seo-input.component.html',
  styleUrls: ['./seo-input.component.scss']
})
export class SeoInputComponent implements OnInit {

  constructor(private dialogService: NbDialogService) { }

  ngOnInit(): void {
  }

  open(){
    /* this.dialogService.open(EditorDialogComponent, {
      context: {
        title: 'This is a title passed to the dialog component',
      },
    }); */
  }

}
